import type { RouteRecordRaw } from 'vue-router';

// Checkout routes per frontend-structure.md §5 + B6.* wireframes.
// All require an authenticated bidder session (handled by the shell
// route guard); B6.1 and B6.3 are receipts, B6.2 is interactive.
export const routes: RouteRecordRaw[] = [
  {
    path: '/:slug/checkout',
    name: 'checkout-self',
    component: () => import('./pages/SelfCheckoutPage.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/:slug/checkout/auto-receipt',
    name: 'checkout-auto-receipt',
    component: () => import('./pages/AutoReceiptPage.vue'),
    meta: { requiresAuth: true },
  },
  {
    // Claimed charges and terminal taps only (GT1-488). Submitted non-terminal payments
    // route to the receipt with a clearing notice.
    path: '/:slug/checkout/pending',
    name: 'checkout-pending',
    component: () => import('./pages/PendingPage.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/:slug/checkout/receipt',
    name: 'checkout-receipt',
    component: () => import('./pages/ReceiptPage.vue'),
    meta: { requiresAuth: true },
  },
];
